export default __webpack_public_path__ + "static/media/tv-icon.6381da81.svg";